import React, { Component } from "react";
import { Grid, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import TimeAgo from "react-timeago";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import Functions from "../../../src/util/functions";



function sortChannels(channels) {
  let sortedChannels;
  if (channels.length > 1) {
    sortedChannels = channels.sort((channel1, channel2) => {
      if (channel1.last_message && channel2.last_message) {
        return new Date(channel2.last_message.created_at) - new Date(channel1.last_message.created_at);
      } else if (!channel1.last_message) {
        return 1;
      } else {
        return -1;
      }
    });
  } else {
    sortedChannels = channels;
  }
  return sortedChannels;
}

function scrollCanvasToBottom() {
  const canvas = document.querySelector(".chat-canvas");
  canvas.scrollTop = canvas.scrollHeight;
}

export default class MessagesContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      channels: [],
      currentChannelId: "",
      messages: [],
      addUserDisplay: "none",
      newChannelDisplay: "none",
      userList: [],
      channelList: [],
      userIdsForNewChannel: [],
      userIdsForCurrentChannel: [],
      newChannelName: ""
    };
    this.fetchGroupChannels = this.fetchGroupChannels.bind(this);
    this.fetchGroupChannelMessages = this.fetchGroupChannelMessages.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.submitMessage = this.submitMessage.bind(this);
    this.handleNewChannelClick = this.handleNewChannelClick.bind(this);
    this.handleAddUserClick = this.handleAddUserClick.bind(this);
    this.addUserToNewChannel = this.addUserToNewChannel.bind(this);
    this.addUserToCurrentChannel = this.addUserToCurrentChannel.bind(this);
    this.submitUserIdsForCurrentChannel = this.submitUserIdsForCurrentChannel.bind(this);
    this.createChannel = this.createChannel.bind(this);
    this.changeChannel = this.changeChannel.bind(this);
    this.handleNewChannelNameInput = this.handleNewChannelNameInput.bind(this);
    this.leaveChannel = this.leaveChannel.bind(this);
  }

  componentWillMount() {
    this.setState({ userIdsForNewChannel: [String(this.props.currentUser.id)] }, () => {
      this.fetchGroupChannels();
      this.fetchUsers();
    });
  }

  componentDidMount() {
    window.addEventListener("newMessage", e => {
      const message = e.detail.message;
      if (!this.state.channels.map(channel => channel.id).includes(message.channel_id)) return;
      let channels = Object.assign([], this.state.channels);
      const relevantChannel = channels.find(channel => channel.id == message.channel_id);
      relevantChannel.last_message = message;
      if (relevantChannel.id != this.state.currentChannelId) relevantChannel.user_channels.filter(userChannel => userChannel.user_id == this.props.currentUser.id).forEach(userChannel => userChannel.unread_message_count ++);
      const channelIndex = channels.indexOf(relevantChannel);
      channels[channelIndex] = relevantChannel;
      channels = sortChannels(channels);

      const addMessageToCurrentChannel = message.channel_id == this.state.currentChannelId && message.user_id != this.props.currentUser.id;

      this.setState({ messages: addMessageToCurrentChannel ? this.state.messages.concat([message]) : this.state.messages, channels: channels }, scrollCanvasToBottom);
    });
  }

  fetchGroupChannels(currentChannelId) {
    axios.get("/channels.json")
      .then(res => {
        const channels = sortChannels(res.data);
        currentChannelId = channels.length && !this.state.currentChannelId ? channels[0].id : currentChannelId;
        this.setState({ channels: channels, currentChannelId: currentChannelId, newChannelDisplay: "none", addUserDisplay: "none" }, () => {
          this.fetchGroupChannelMessages();
        });
      });
  }

  fetchGroupChannelMessages() {
    if (!this.state.currentChannelId) return;
    axios.get(`/messages?channel_id=${this.state.currentChannelId}`, { headers: { "Content-Type": "application/json", "Accept": "application/json" } })
      .then(res => {
        let channels = Object.assign([], this.state.channels);
        const currentChannel = channels.find(channel => channel.id == this.state.currentChannelId);
        if (!currentChannel) {
          return;
        }
        currentChannel.user_channels.filter(userChannel => userChannel.user_id == this.props.currentUser.id).forEach(userChannel => userChannel.unread_message_count = 0);
        const channelIndex = channels.indexOf(currentChannel);
        channels[channelIndex] = currentChannel;

        this.setState({ messages: res.data, channels: channels }, scrollCanvasToBottom);
        const notificationIcon = document.querySelector(".nav + .notification");
        if (notificationIcon) notificationIcon.style.visibility = "hidden";
      });
  }

  fetchUsers() {
    axios.get("/users.json")
      .then(res => {
        this.setState({ userList: res.data });
      });
  }

  handleKeyDown(e) {
    if (e.keyCode == "13") {
      e.preventDefault();
      this.submitMessage(e.target.value);
      e.target.value = "";
      setTimeout(() => {
        scrollCanvasToBottom();
      }, 500);
    }
  }

  handleNewChannelClick() {
    const newDisplay = this.state.newChannelDisplay == "block" ? "none" : "block";
    this.setState({ addUserDisplay: "none", newChannelDisplay: newDisplay });
  }

  handleAddUserClick() {
    const newDisplay = this.state.addUserDisplay == "block" ? "none" : "block";
    this.setState({ addUserDisplay: newDisplay, newChannelDisplay: "none" });
  }

  addUserToCurrentChannel(e) {
    const userItem = e.target.closest(".modal-messaging-list__item");
    if (this.state.userIdsForCurrentChannel.includes(userItem.dataset.userId)) {
      const newUserIds = Object.assign([], this.state.userIdsForCurrentChannel);
      const indexToRemove = newUserIds.indexOf(userItem.dataset.userId);
      newUserIds.splice(indexToRemove, 1);
      this.setState({ userIdsForCurrentChannel: newUserIds });
    } else {
      this.setState({ userIdsForCurrentChannel: this.state.userIdsForCurrentChannel.concat([userItem.dataset.userId]) });
    }
  }

  addUserToNewChannel(e) {
    const userItem = e.target.closest(".modal-messaging-list__item");
    if (this.state.userIdsForNewChannel.includes(userItem.dataset.userId)) {
      const newUserIds = Object.assign([], this.state.userIdsForNewChannel);
      const indexToRemove = newUserIds.indexOf(userItem.dataset.userId);
      newUserIds.splice(indexToRemove, 1);
      this.setState({ userIdsForNewChannel: newUserIds });
    } else {
      this.setState({ userIdsForNewChannel: this.state.userIdsForNewChannel.concat([userItem.dataset.userId]) });
    }
  }

  submitUserIdsForCurrentChannel() {
    const newUserIds = this.state.userIdsForCurrentChannel;
    axios.put(`/channels/${this.state.currentChannelId}.json`, {
      channel: {
        add_user_ids: newUserIds
      },
      authenticity_token: Functions.getMetaContent("csrf-token")
    }).then(res => {
      axios.post("/messages.json", {
        message: {
          message_type: "MESG",
          user_id: this.props.currentUser.id,
          message: "",
          data: `NEW USERS [${newUserIds}]`,
          channel_id: this.state.currentChannelId
        },
        authenticity_token: Functions.getMetaContent("csrf-token")
      })
      this.fetchGroupChannels(res.data.id);
    }).catch(err => {
      console.error(err);
    });
  }

  submitMessage(message) {
    if (message.length == 0) return;
    axios.post("/messages.json", {
      message: {
        message_type: "MESG",
        user_id: this.props.currentUser.id,
        message: message,
        channel_id: this.state.currentChannelId
      },
      authenticity_token: Functions.getMetaContent("csrf-token")
    }).then(res => {
      const channels = Object.assign([], this.state.channels);
      const currentChannel = channels.find(channel => channel.id == this.state.currentChannelId);
      const channelIndex = channels.indexOf(currentChannel);
      currentChannel.last_message = res.data;
      channels[channelIndex] = currentChannel;

      this.setState({ messages: this.state.messages.concat([res.data]), channels: sortChannels(channels) });
    });
  }

  createChannel() {
    // const userNicknames = this.state.userList.filter(user => this.state.userIdsForNewChannel.includes(String(user.id))).map(user => user.full_name).join(", ");
    axios.post("/channels.json", {
      channel: {
        name: this.state.newChannelName,
        user_ids: this.state.userIdsForNewChannel,
        is_distinct: true
      },
      authenticity_token: Functions.getMetaContent("csrf-token")
    }).then(res => {
      this.fetchGroupChannels(res.data.id);
    }).catch(err => {
      console.error(err);
    }).then(() => {
      this.setState({ newChannelDisplay: "none", addUserDisplay: "none" })
    });
  }

  handleNewChannelNameInput(e) {
    this.setState({ newChannelName: e.target.value });
  }

  changeChannel(e) {
    this.setState({ currentChannelId: e.target.closest(".left-nav-channel-group").dataset.channelUrl, addUserDisplay: "none" }, this.fetchGroupChannelMessages);
  }

  leaveChannel() {
    axios.post("/messages.json", {
      message: {
        message_type: "MESG",
        user_id: this.props.currentUser.id,
        message: "",
        data: "LEFT THE CONVERSATION",
        channel_id: this.state.currentChannelId
      },
      authenticity_token: Functions.getMetaContent("csrf-token")
    }).then(() => {
      axios.post("/channels/remove_user.json", {
        channel_id: this.state.currentChannelId,
        user_id: this.props.currentUser.id,
        authenticity_token: Functions.getMetaContent("csrf-token")
      }).then(() => {
        const revisedChannels = this.state.channels.filter(channel => channel.id != this.state.currentChannelId);
        this.setState({ currentChannelId: (revisedChannels[0] || {}).id, channels: revisedChannels }, this.fetchGroupChannelMessages);
      });
    });
  }

  render() {
    const channels = this.state.channels.map((channel, i) => {
      let lastMessageData;
      if (channel.last_message) {
        let newMessageNotification;
        if (channel.user_channels.find(userChannel => userChannel.user_id == this.props.currentUser.id).unread_message_count > 0) {
          newMessageNotification = <img className="notification" src="/assets/notification-bell-d4f3828feb3630b9cb4f5119c4f49e815161e99e090ce5c1495572217d496144.png" />;
        }
        lastMessageData = (
          <div>
            <div className="left-nav-channel-lastmessage">{channel.last_message.message.length > 50 ? `${channel.last_message.message.slice(0, 47)}...` : channel.last_message.message}</div>
            <div className="left-nav-channel-lastmessagetime">
              <span>
                <img src="/img/icon-time.png" style={{verticalAlign: "middle", padding: "0 6px 2px 0"}} />
                <TimeAgo date={channel.last_message.created_at} />
              </span>
              {newMessageNotification}
            </div>
          </div>
        );
      }
      const names = channel.users.map(user => <li key={user.id}>{user.full_name}</li>);
      const listOfUsersInChannel = (
        <ul>
          {names}
        </ul>
      );
      const tooltip = <Tooltip id={`channel${i}`} className="channel-user-list">{listOfUsersInChannel}</Tooltip>;
      const styles = channel.cover_url ? { backgroundImage: `url(${channel.cover_url})` } : {};
      return (
        <OverlayTrigger key={channel.id} placement="right" overlay={tooltip}>
          <div
            className={`left-nav-channel left-nav-channel-group ${this.state.currentChannelId == channel.id ? "active" : ""}`}
            data-channel-url={channel.id}
            style={styles}
            onClick={this.changeChannel}
            key={`channel${i}`}
          >
            <div className="left-nav-channel-members">{channel.name}</div>
            {lastMessageData}
          </div>
        </OverlayTrigger>
      );
    });

    const messages = this.state.messages.map((message, i) => {
      if (message) {
        let date;
        const options = {
          weekday: "short",
          year: "numeric",
          month: "numeric",
          day: "numeric"
        };
        if (i == 0) {
          const thisDate = new Date(message.created_at);
          const thisDateString = thisDate.toLocaleDateString(navigator.language, options).replace(/,/, "");
          date = <div className="date">{thisDateString}</div>
        } else {
          const thisDate = new Date(message.created_at);
          const lastDate = new Date(this.state.messages[i - 1].created_at);
          const thisDateString = thisDate.toLocaleDateString(navigator.language, options).replace(/,/, "");
          const lastDateString = lastDate.toLocaleDateString(navigator.language, options).replace(/,/, "");
          if (thisDateString != lastDateString) {
            date = <div className="date">{thisDateString}</div>
          }
        }
        let messageBody;
        if (message.data == "LEFT THE CONVERSATION") {
          messageBody = <div className="announcement">{(message.user || {}).full_name} left the conversation</div>;
        } else if (message.data && message.data.match(/NEW USERS/)) {
          let newUsers = this.state.userList.filter(user => JSON.parse(message.data.match(/\[.+\]/)).includes(user.id))
                            .map(user => user.full_name)
                            .join(", ");
          if (newUsers.match(/,/)) {
            const indices = [];
            const element = ',';
            let index = newUsers.indexOf(element);
            while (index != -1) {
              indices.push(index);
              index = newUsers.indexOf(element, index + 1);
            }
            newUsers = newUsers.substr(0, indices[indices.length - 1]) + " and" + newUsers.substr(indices[indices.length - 1] + 1, 99);
          }
          messageBody = <div className="announcement">{(message.user || {}).full_name} added {newUsers}</div>;
        } else {
          messageBody = (
            <div className="chat-canvas__list">
              <label className="chat-canvas__list-name chat-canvas__list-name__user" data-userid={message.user_id}>{(message.user || {}).full_name}</label>
              <label className="chat-canvas__list-separator">:</label>
              <label className="chat-canvas__list-text" data-messageid={message.message_id}>{message.message}</label>
              <label className="timestamp">{new Date(message.created_at).toTimeString().match(/\d+:\d+/)[0]}</label>
            </div>
          );
        }
        return (
          <div key={`message${i}`}>
            {date}
            {messageBody}
          </div>
        );
      }
    });

    const userList = this.state.userList.map((user, i) => {
      if (user.id != this.props.currentUser.id) {
        return (
          <div className="modal-messaging-list__item" style={{ background: `url(${user.image}) no-repeat 20px center #fff` }} key={`user${i}`} onClick={this.addUserToNewChannel} data-user-id={user.id}>
            {user.full_name}
            <div className={`modal-messaging-list__icon${this.state.userIdsForNewChannel.includes(String(user.id)) ? " modal-messaging-list__icon--select" : ""}`}></div>
          </div>
        );
      }
    });

    const addUserList = this.state.userList.map((user, i) => {
      const currentChannel = this.state.channels.find(channel => channel.id == this.state.currentChannelId);
      if (!currentChannel || !currentChannel.users.map(user => user.id).includes(user.id)) {
        return (
          <div className="modal-messaging-list__item" style={{ background: `url(${user.image}) no-repeat 20px center #fff` }} key={`addUser${i}`} onClick={this.addUserToCurrentChannel} data-user-id={user.id}>
            {user.full_name}
            <div className={`modal-messaging-list__icon${this.state.userIdsForCurrentChannel.includes(String(user.id)) ? " modal-messaging-list__icon--select" : ""}`}></div>
          </div>
        );
      }
    });

    const channelList = this.state.channelList.map((channel, i) => {
      return (
        <div className="modal-open-chat-list__item" key={`channel${i}`}>
          <img src={channel.cover_url} />
          {channel.name}
        </div>
      );
    });

    const noChannels = (this.state.channels || []).length === 0;

    return (
      <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
        <Grid className="with-background messages-page">
          <Banner heading="Messages" />
          <Row>
            <Col md={12}>
              <div className="sample-body">

                <div className="left-nav">

                  <div className="left-nav-channel-select">
                    <button type="button" className={`left-nav-button left-nav-messaging${this.state.newChannelDisplay == "block" ? " left-nav-messaging--active" : ""}`} id="btn_messaging_chat" onClick={this.handleNewChannelClick}>
                      New conversation
                    </button>
                  </div>

                  <div className="left-nav-add-user">
                    <button type="button" className={`left-nav-button left-nav-messaging${this.state.addUserDisplay == "block" ? " left-nav-messaging--active" : ""}`} id="btn_messaging_chat" onClick={this.handleAddUserClick}>
                      Add user
                    </button>
                  </div>

                  <div className="left-nav-channel-section">


                    <div id="open_channel_list"></div>

                    <div className="left-nav-channel-title title-messaging">Current conversations</div>
                    <div id="messaging_channel_list">
                      {channels}
                    </div>
                  </div>

                  <div className="left-nav-user">
                    <div className="white-background">
                      <div className="left-nav-user left-nav-user-icon" style={{background: `url(${this.props.currentUser.image}) no-repeat center center`}}></div>
                    </div>

                    <div className="left-nav-user left-nav-login-user">
                      <div className="left-nav-user left-nav-user-title">username</div>
                      <div className="left-nav-user left-nav-user-nickname">{this.props.currentUser.full_name}</div>
                    </div>
                  </div>

                </div>



                <div className="right-section">

                  <div className="right-section__modal-bg" style={{display: "none"}}></div>

                  <div className="chat-empty" style={{display: (noChannels ? "block" : "none")}}>
                    <div className="chat-empty chat-empty__tile">WELCOME</div>
                    <div className="chat-empty chat-empty__icon"></div>
                    <div className="chat-empty chat-empty__desc">
                      Create or select a channel to chat in.<br />
                      If you don't have a channel to participate,<br />
                      go ahead and create your first channel now.
                    </div>
                  </div>


                  <div className="chat" style={{display: (noChannels ? "none" : "block")}}>
                    <div className="top-controls">
                      <button type="button" onClick={this.leaveChannel}>Leave conversation</button>
                    </div>

                    <div className="chat-canvas">
                      {messages}
                    </div>

                    <div className="chat-input">
                      <div id="container">
                      </div>
                      <label className="chat-input-file" htmlFor="chat_file_input">
                        <input type="file" name="file" id="chat_file_input" style={{display: "none"}} />
                      </label>

                      <div className="chat-input-text">
                        <textarea className="chat-input-text__field" placeholder="Type here..." autoFocus="autofocus"onKeyDown={this.handleKeyDown}></textarea>
                      </div>
                    </div>
                    <label className="chat-input-typing"></label>
                  </div>

                </div>

                <div className="modal-messaging" style={{ display: this.state.newChannelDisplay }}>
                  <div className="modal-messaging-top">
                    <label className="modal-messaging-top__title">User list</label>
                    <div>Select one or more users to be added to the conversation</div>
                    <div className="conversation-name-input-container">
                      <label>Conversation name:</label><input className="form-control" type="text" value={this.state.newChannelName} onChange={this.handleNewChannelNameInput} />
                    </div>
                  </div>
                  <div className="modal-messaging-list">
                    {userList}
                  </div>
                  <div className="modal-messaging-bottom">
                    <button type="button" className="modal-messaging-bottom__button" onClick={this.createChannel} disabled={!this.state.newChannelName}>Start conversation</button>
                  </div>
                </div>

                <div className="modal-messaging" style={{ display: this.state.addUserDisplay }}>
                  <div className="modal-messaging-top">
                    <label className="modal-messaging-top__title">User list</label>
                    <div>Select one or more users to be added to the conversation</div>
                  </div>
                  <div className="modal-messaging-list">
                    {addUserList}
                  </div>
                  <div className="modal-messaging-bottom">
                    <button type="button" className="modal-messaging-bottom__button" onClick={this.submitUserIdsForCurrentChannel}>Add users</button>
                  </div>
                </div>

              </div>
            </Col>
          </Row>
        </Grid>
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/MessagesContainer.jsx.erb